import React from 'react'
import { connect } from 'react-redux'
import toLower from 'lodash/toLower'
import moment from 'moment'
import Modal from 'react-responsive-modal'
import FormChangeImage from '../../Containers/Attraction/FormChangeImage'

import AttractionActions from '../../Redux/AttractionRedux'

class FormUpdateImage extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      tab: null,
      form: {
        language_code: toLower(props.setting.language_code),
        highlights: '',
        additional_info: '',
        description: ''
      },
      files: {},
      showModal: null,
      selected: {
        item: {},
        dimension: null,
        banner: null
      }
    }
  }

  componentDidMount = () => {
    let filter = {
      language_code: this.props.setting.language_code,
      currency_code: this.props.setting.currency_code
    }
    let data = {
      id: this.props.detailId,
      filter
    }
    this.props.getAttractionDetail(data)
  }

  _toggleModal = (modalId = null, item, dimension) => {
    this.setState({
      showModal: modalId,
      selected: {
        ...this.state.selected,
        item,
        dimension
      }
    })
  }

  _toggleTab = (tabName = null) => {
    this.setState({
      tab: tabName
    })
  }

  render () {
    const { detail, fetching, err, processing } = this.props.attraction

    return (
      <div className='section' style={{ width: '75vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>
            Attraction Update
            {(fetching || processing) && <div className='badge badge-info ml-2'>{fetching ? 'Loading' : 'Processing'} ...</div>}
          </h4>
        </div>
        {err && <div className='alert alert-danger'>{err}</div>}

        <div>
          {detail.local_photos && detail.local_photos.map((item, i) => {
            return (
              <div key={i} className='mb-3' style={{ borderBottom: '1px solid #ddd' }}>
                <div className='table-responsive'>
                  <table className='table table-hover table-bordered'>
                    <thead>
                      <tr>
                        <th>Caption</th>
                        <th>Dimension</th>
                        <th>Image</th>
                        <th>Edit Image</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(item.paths).map((dimension, key) => (
                        <tr key={key}>
                          {key === 0 &&
                            <td rowSpan={Object.keys(item.paths).length}>{item.caption || '-'}</td>
                          }
                          <td>
                            {dimension}
                          </td>
                          <td>
                            <img src={item.paths[dimension] + '&v=' + moment(item.updated_at).unix()} alt='' height='175px' className='img img-responsive' />
                          </td>
                          <td>
                            <button className='btn btn-primary' onClick={() => this._toggleModal('change-image', item.paths[dimension], dimension)}>Change Image</button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )
          })}
          <Modal open={this.state.showModal === 'change-image'} onClose={this._toggleModal} closeOnOverlayClick>
            <FormChangeImage attractionId={this.props.detailId} item={this.state.selected.item} dimension={this.state.selected.dimension} closeModal={() => this._toggleModal()} />
          </Modal>
        </div>
        <div className='form-group d-flex justify-content-end'>
          <button className='btn btn-lg btn-secondary' onClick={() => this.props.closeModal()}>Close</button>
          <button className='btn btn-lg btn-primary ml-2' onClick={() => this._submit()}>Save</button>
        </div>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  attraction: state.attraction
})

const dispatchToProps = (dispatch) => ({
  getAttractionDetail: (data) => dispatch(AttractionActions.attractionDetailRequest(data))
})

export default connect(stateToProps, dispatchToProps)(FormUpdateImage)



// WEBPACK FOOTER //
// ./src/Containers/Attraction/FormUpdateImage.js